import React, { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { styled } from "@glitz/react";
import Button from "./basic/Button";
import { spacing, Theme, Size } from "../theme";

interface Props {
  orderId?: number | string | null;
  returnUrl?: string;
  onSuccess: (paymentIntentId?: string) => void;
}

const StripePaymentForm: React.FC<Props> = ({ orderId, returnUrl: returnUrlProp, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const base = process.env.PUBLIC_URL || '';
  const returnUrl = returnUrlProp
    || (orderId != null
      ? `${window.location.origin}${base}/checkout/pay/${orderId}`
      : `${window.location.origin}${base}/checkout/success`);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setLoading(true);
    setError(null);
    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnUrl,
      },
      redirect: "if_required",
    });
    setLoading(false);
    if (result.error) {
      setError(result.error.message || "Betalningen misslyckades");
      return;
    }
    const piId = result.paymentIntent?.id;
    onSuccess(piId);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <PaymentElement />
      {error && <ErrorText>{error}</ErrorText>}
      <ButtonWrapper>
        <Button
          type="submit"
          as={Theme.Primary}
          size={Size.Small}
          disabled={!stripe || loading}
        >
          {loading ? "Bearbetar…" : "Betala"}
        </Button>
      </ButtonWrapper>
    </Form>
  );
};

const Form = styled.form({
  display: "flex",
  flexDirection: "column",
  gap: spacing.l,
  maxWidth: "400px",
  margin: { x: "auto", y: 0 },
});

const ErrorText = styled.div({
  color: "#c00",
  fontSize: "14px",
});

const ButtonWrapper = styled.div({
  marginTop: spacing.s,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
});

export default StripePaymentForm;
